import gql from 'graphql-tag';

export default gql`
    mutation SendMessageToConversation($input: SendMessageToConversationInput) {
        sendMessageToConversation(input: $input) {
            conversationId
            messageId
            messageUserId
        }
    }
`;
